import { render, staticRenderFns } from "./importTemplat.vue?vue&type=template&id=c659b7fe"
import script from "./importTemplat.vue?vue&type=script&lang=js"
export * from "./importTemplat.vue?vue&type=script&lang=js"
import style0 from "./importTemplat.vue?vue&type=style&index=0&id=c659b7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports